import { useState } from "react";
import { FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function AssetExportButton() {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/asset-export", { params: { month }, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data); a.download = `rekap-aset-${month}.xlsx`; a.click();
      URL.revokeObjectURL(a.href);
      toast.success(`Rekap aset ${month} diunduh`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-1.5" data-testid="asset-export">
      <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-9 w-40 text-xs" data-testid="asset-export-month" />
      <Button variant="outline" className="h-9" onClick={download} disabled={busy || !month} data-testid="asset-export-btn"><FileSpreadsheet className="w-4 h-4 mr-1.5 text-emerald-500" /> {busy ? "Menyiapkan..." : "Ekspor Excel"}</Button>
    </div>
  );
}
